export enum SocketEventTypes {
  SEND_SEAT = 'send-seat',
  BUS_CHANGE = 'availability-change',
  ERROR = 'message-error',
  TIME_EXPIRED = 'time-expired',
  SELECTED_SEATS = 'selected-seats',
  SELECTED_STANDDING = 'selected-standing',
  SELECTED_WHEELCHAIR = 'selected-wheelchair',
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  REGISTER = 'register',
  GET_SELECTED_SEAT = 'getselected-seats',
  SELECTED_WITHOUT_NUMBER = 'selected-withoutnumber',
  BUS_UPDATED = 'bus-updated',
  PURCHASE_DONE = 'purchase-done'
};

export enum ESocketMessages {
  COMUNICATION = 'Error de comunicacion'
};
